const DEFINITION_NAME = {
  TEACHER_B2B: 'Professor B2B',
  ADMIN: 'Administrador',
};

export { DEFINITION_NAME };
